import { render, staticRenderFns } from "./indicators.component.vue?vue&type=template&id=082c6f56&scoped=true&"
import script from "./indicators.component.vue?vue&type=script&lang=ts&"
export * from "./indicators.component.vue?vue&type=script&lang=ts&"
import style0 from "./indicators.component.vue?vue&type=style&index=0&id=082c6f56&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082c6f56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VForm } from 'vuetify/lib/components/VForm';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VChip,VForm,VList,VListItem,VListItemTitle,VMenu})
